export function timeToDay(timeSecond:string) {
    if (timeSecond == undefined || timeSecond === '') {
        return 0;
    }
    let rangeDateNum = (new Date().getTime() / 1000 - Number(timeSecond)) / (3600*24);
    let day = Math.floor(rangeDateNum) + 1;
    return day;
}